// import { GameData } from "../../gamestate/gameData";
import { convertCreditsFromServerToClient } from "../../../common/datastructures/Credits";
import { ImageText } from "../../ImageText";
// import { getParameterByName } from "../../../common/getParameters";
import { playJackpotMusic } from "../jackpotGlobalFunctions";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { enablePlay } from "../../functions/Functions_GameBar";
import { Howl } from "howler";
import { updateBalance } from "../../functions/Functions_General";
import DeviceChecker from "../../functions/helper.ts/DeviceChecker";

export class WinScreen {
  private activeGameData: CommonData;
  private parentContainer: PIXI.Container;
  private scoreContainer: PIXI.Container;
  private megaWinTexture: PIXI.Texture;
  private midiWinTexture: PIXI.Texture;
  private miniWinTexture: PIXI.Texture;
  private winBody: PIXI.Sprite;
  private winBodyTweenOut: PIXI.tween.Tween;
  private scoreContainerTweenIn: PIXI.tween.Tween;
  private scoreDisplayBG: PIXI.Sprite;
  private scoreDisplay: Array<PIXI.Sprite>; //list of numbers;
  private scoreCurrencyDisplay: ImageText;
  private win_sound: Howl;
  private close: PIXI.Sprite;
  private closeText: PIXI.Text;
  private scoreContainerTweenOut: PIXI.tween.Tween;
  private winBodyTweenIN: PIXI.tween.Tween;
  private winValue: number;
  private winIndex: number;
  private closeBtnContainer: PIXI.Container;
  //---------

  constructor(activeGameData: CommonData) {
    this.activeGameData = activeGameData;
    this.parentContainer = new PIXI.Container();
    this.scoreContainer = new PIXI.Container();
    this.closeBtnContainer = new PIXI.Container();
    this.megaWinTexture = PIXI.Texture.fromImage("megaJackpotText_display.png");
    this.midiWinTexture = PIXI.Texture.fromImage("midipotText_display.png");
    this.miniWinTexture = PIXI.Texture.fromImage("minipotText_display.png");

    this.winBody = new PIXI.Sprite(this.miniWinTexture);
    this.winBodyTweenIN = PIXI.tweenManager.createTween(this.winBody);
    this.winBodyTweenOut = PIXI.tweenManager.createTween(this.winBody);
    this.scoreContainerTweenIn = PIXI.tweenManager.createTween(
      this.scoreContainer
    );
    this.scoreContainerTweenOut = PIXI.tweenManager.createTween(
      this.scoreContainer
    );

    this.scoreDisplayBG = new PIXI.Sprite(
      PIXI.Texture.fromImage("bgSmallWin.png")
    );
    this.scoreDisplay = []; //list of numbers;
    this.win_sound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/12972918_jackpot.m4a?" +
          "version=" +
          activeGameData.gameVersion,
      ],
      volume: 1,
      // loop:true,
      // preload:true,
      sprite: {
        // music: [0, 20869,true],
        win: [0, 8650, false],
      },
    });

    this.activeGameData.bonusMusicList.push(this.win_sound);

    this.create();

    this.setTestValues(1999, 1);
  }

  private create = (): void => {
    this.winBody.y = this.activeGameData.size[1] / 2 - 100 - 40;
    this.winBody.alpha = 0;
    this.winBody.anchor.set(0.5);
    this.winBody.x = this.activeGameData.size[0] / 2;

    this.winBodyTweenIN
      .from({ alpha: 0, scale: { x: 0.8, y: 0.8 } })
      .to({ alpha: 1, scale: { x: 1.2, y: 1.2 } });
    this.winBodyTweenIN.time = 2000;
    this.winBodyTweenIN.delay = 500;
    this.winBodyTweenIN.easing = PIXI.tween.Easing.outBack();

    this.winBodyTweenOut
      .from({ alpha: 1, scale: { x: 1.2, y: 1.2 } })
      .to({ alpha: 0, scale: { x: 0.8, y: 0.8 } });
    this.winBodyTweenOut.time = 1000;
    this.winBodyTweenOut.delay = 500;
    this.winBodyTweenOut.easing = PIXI.tween.Easing.outBack();

    this.scoreContainerTweenIn
      .from({ alpha: 0, y: this.activeGameData.size[1] / 2 - 100 })
      .to({ alpha: 1, y: this.activeGameData.size[1] / 2 - 30 });
    this.scoreContainerTweenIn.time = 1000;
    this.scoreContainerTweenIn.delay = 500;
    this.scoreContainerTweenIn.easing = PIXI.tween.Easing.outBack();

    this.scoreContainerTweenOut
      .from({ alpha: 1, y: this.activeGameData.size[1] / 2 - 30 })
      .to({ alpha: 0, y: this.activeGameData.size[1] / 2 - 100 });
    this.scoreContainerTweenOut.time = 1000;
    this.scoreContainerTweenOut.delay = 0;
    this.scoreContainerTweenOut.easing = PIXI.tween.Easing.outBack();

    // this.scoreContainerTweenOut.on('start', this.closeGameWheel.bind(this))

    this.parentContainer.addChild(this.winBody);
    this.parentContainer.addChild(this.scoreContainer);

    this.scoreDisplayBG.scale.set(1.3);
    this.scoreDisplayBG.scale.x = 1.6;
    this.scoreDisplayBG.y = 175;
    this.scoreDisplayBG.x = -this.scoreDisplayBG.width / 2;

    // this.scoreDisplayBG.alpha=1;
    this.winBody.addChild(this.scoreDisplayBG);

    this.scoreCurrencyDisplay = new ImageText(
      this.activeGameData.currency,
      this.winBody
    );
    let labelP = this.scoreCurrencyDisplay.getParent();
    labelP.y = 380;
    labelP.scale.set(0.65);
    labelP.x = -labelP.width / 2 + 100;
    labelP.cacheAsBitmap = true;
    // {
    this.winBodyTweenIN.time = 1;
    this.scoreContainerTweenIn.time = 1;
    this.winBodyTweenIN.delay = 0;
    this.scoreContainerTweenIn.delay = 0;
    // }

    this.close = new PIXI.Sprite(PIXI.Texture.fromFrame("jackpotClose.png"));

    this.closeText = new PIXI.Text(
      this.activeGameData.gameTextGeneral.continue,
      {
        fontFamily: this.activeGameData.gameTextStyle.gameFont,
        fontSize: 45,
        fontWeight: "bold",
        fill: ["#ffffff"],
      }
    );
    this.closeText.anchor.set(0.5);
    this.close.addChild(this.closeText);
    this.closeBtnContainer.addChild(this.close);
    this.parentContainer.addChild(this.closeBtnContainer);
    this.close.anchor.set(0.5);
    this.close.position.set(975, this.parentContainer.height + 100);
    this.close.buttonMode = true;
    this.close.interactive = true;
    // this.close.hitArea=new PIXI.Rectangle(-400,-1000,400,50);
    this.close.on("pointertap", this.clickClose, false);
    this.close.on("mouseover", function() {
      this.alpha = 1;
    });
    this.close.on("mouseout", function() {
      this.alpha = 0.8;
    });

    this.enableCloseBtn(false);
  };

  private goldenScoreDisplay = (score: number): void => {
    //input a score number
    let value = convertCreditsFromServerToClient(score);
    let scoreString = value.toFixed(2).toString();

    // let value =1000// convertCreditsFromServerToClient(score)
    // let scoreString = (value.toFixed(2)).toString();

    // console.log("before: " ,this.scoreDisplay.length);
    let x = 0;
    let y = 75;
    for (var i = 0; i < this.scoreDisplay.length; i++) {
      // this.scoreContainer.removeChild(this.scoreDisplay[i])
      this.scoreDisplay[i].destroy();
    }

    //   console.log("after: " ,this.scoreDisplay.length);
    this.scoreDisplay = [];
    this.scoreContainer.alpha = 0;

    for (var i = 0; i < scoreString.length; i++) {
      // if (typeof(parseInt(scoreString[i]))==='number') {

      if (isNaN(parseInt(scoreString[i])) === false) {
        // if it is a number
        // console.log(i,parseInt(scoreString[i]))

        let n = parseInt(scoreString[i]);
        // this.scoreDisplay[i] = new PIXI.Sprite(PIXI.Texture.fromImage("font_000" + (n + 48) + ".png"));
        this.scoreDisplay[i] = new PIXI.Sprite(
          PIXI.Texture.fromImage("font" + n + ".png")
        );
        this.scoreDisplay[i].x = x;
        this.scoreDisplay[i].y = y;
        this.scoreContainer.addChild(this.scoreDisplay[i]);
        if (typeof parseInt(scoreString[i + 1]) === "number") {
          x += 100;
        } else {
          x += 70;
        }
      } else {
        this.scoreDisplay[i] = new PIXI.Sprite(
          PIXI.Texture.fromImage("fontDot.png")
        );
        this.scoreDisplay[i].x = x;
        this.scoreDisplay[i].y = y;
        this.scoreContainer.addChild(
          this.scoreDisplay[this.scoreDisplay.length - 1]
        );
        x += 70;
      }
      //jackpotScorecontainer.pivot.set(0.5);

      this.scoreContainer.x =
        -(this.scoreContainer.width - this.activeGameData.size[0]) / 2;
    }

    // this.spacing()// add space between the text of jackpot ;
    this.resize();
    this.enableCloseBtn(true);
  };

  // spacing() {
  //     // console.log(this.scoreDisplay.length);
  //     let spacing = 0;
  //     let spacingIndex = -1;

  //     for (let i = this.scoreDisplay.length - 1; i >= 0; i--) {
  //         if (i < this.scoreDisplay.length - 3) {
  //             spacingIndex++;
  //             if (spacingIndex === 3) {
  //                 spacingIndex = 0;
  //                 spacing += 40;

  //             }
  //             this.scoreDisplay[i].x -= spacing;
  //         }
  //     }
  //     this.scoreContainer.x = -(this.scoreContainer.width - this.activeGameData.size[0]) / 2;

  // }

  private resize = (): void => {
    // console.log(this.scoreContainer.width);
    let max_width = 1440;
    if (this.scoreContainer.width > max_width) {
      this.scoreContainer.scale.set(max_width / this.scoreContainer.width, 1);
      this.scoreContainer.x =
        -(this.scoreContainer.width - this.activeGameData.size[0]) / 2;
    }
  };

  private displayIN = (): void => {
    // console.log("EXIT")

    //--jackpotSpinEnded//-
    this.activeGameData.jackPotGame.setJackpotEnded(true);
    this.activeGameData.jackPotGame.autoHideJackpotLabelOnPortrait();

    //--
    this.winValue = this.activeGameData.jackpotContext.jackpotSpinWin.credits.amount;
    this.winIndex = this.activeGameData.jackpotContext.jackpotSpinWin.jackpotLevel;

    //  this.winValue = 100
    //  this.winIndex = 1

    // // //testValues

    if (this.winIndex === 1) {
      this.winBody.texture = this.miniWinTexture;
      this.goldenScoreDisplay(this.winValue);
    }
    if (this.winIndex === 2) {
      this.winBody.texture = this.midiWinTexture;
      this.goldenScoreDisplay(this.winValue);
    }
    if (this.winIndex === 3) {
      this.winBody.texture = this.megaWinTexture;
      this.goldenScoreDisplay(this.winValue);
    }
    this.winBodyTweenIN.reset();
    this.winBodyTweenIN.start();
    this.win_sound.play("win");

    this.scoreContainerTweenIn.reset();
    this.scoreContainerTweenIn.start();

    // if(winIndex==3)
    // {
    //     this.scoreContainerTweenOut.delay =20000;
    // }
    // else{
    //     this.scoreContainerTweenOut.delay =7000;
    // }
  };

  private displayOut = (): void => {
    this.winBodyTweenOut.reset();
    this.winBodyTweenOut.start();
    playJackpotMusic(this.activeGameData, false);
  };

  public setParent = (parent: PIXI.Container): void => {
    parent.addChild(this.parentContainer);
  };

  public setVisibile = (bool: boolean): void => {
    if (bool) {
      this.displayIN();
    } else {
      this.displayOut();
    }
  };

  public stop() {
    this.win_sound.stop();

    this.activeGameData.jumpCoin.stop();

    this.winBody.alpha = 0;
    this.winBodyTweenOut.stop();

    this.scoreContainerTweenIn.stop();
    this.scoreContainerTweenOut.stop();
    this.scoreContainer.alpha = 0;
    this.winBodyTweenIN.stop();
    playJackpotMusic(this.activeGameData, false);
    this.enableCloseBtn(false);
    this.close.interactive = false;
    this.close.buttonMode = false;
    this.close.alpha = 0;

    // console.log('REQUEST BALANCE ON STOP')
    if (this.activeGameData.replayMode === false) {
      this.activeGameData.requestNewBalance(this.activeGameData);
    } else {
      //  if(this.activeGameData.isEmulation)
      // {
      //    this.emulationJackpotUpdateBalance();
      // }
      // else
      // {
      // //onn recovery dont do the balance requst and apply the balance of the  context;
      // updateBalance(this.activeGameData);
      // }
      updateBalance(this.activeGameData);
    }

    this.activeGameData.setAllowedInputs(this.activeGameData);
  }

  // private emulationJackpotUpdateBalance=():void=>
  // {
  //     let jackpotWinAmount =this.activeGameData.betResponse.jackpotContext.jackpotSpinWin.credits.amount;
  //     this.activeGameData.betResponse.playerBalance.creditsBalance.amount+=jackpotWinAmount;
  //     //-

  //         // console.log("FINISHED and reset balance")
  //         if (this.activeGameData.updateBalanceOnRecovery) {
  //             this.activeGameData.balance.updateValue(
  //                 this.activeGameData.betResponse.playerBalance.creditsBalance.amount
  //           );
  //           this.activeGameData.gameBar.setBalValue(
  //             this.activeGameData.balance.getDisplayValue()
  //           );
  //           //--
  //       }

  //         // this.activeGameData.winValue.updateValue(0);
  //         // this.activeGameData.gameBar.setWinValue(
  //         //     this.activeGameData.winValue.getDisplayValue()
  //         // );
  //         //    console.log("bal +++++++++++++++++++++++++++++++ after" ,activeGameData.betResponse)

  // }
  private enableCloseBtn(bool: boolean) {
    this.close.interactive = bool;
    this.close.buttonMode = bool;
    if (bool == true) {
      this.close.alpha = 1;
    } else {
      this.close.alpha = 0;
    }
  }
  private clickClose = (): void => {
    // console.log("close jackpot n coins")
    this.scoreContainer.alpha = 0;
    this.goldenScoreDisplay(0);
    // this.scoreContainerTweenOut.reset();
    // this.scoreContainerTweenOut.start();

    this.closeGameWheel();
    this.activeGameData.jumpCoin.stop();
    // console.log('REQUEST BALANCE ON CLOSE')

    // this.activeGameData.requestNewBalance(this.activeGameData);

    // this.activeGameData.jackPotGame.setNewID();
    this.enableCloseBtn(false);

    this.activeGameData.resetAllBtns(this.activeGameData);

    enablePlay(true, this.activeGameData);
    this.activeGameData.setAllowedInputs(this.activeGameData);
  };

  public setBodytTweenInReset() {
    this.winBodyTweenIN.reset();
  }

  public setScoreContainertTweenOutReset() {
    // this.scoreContainerTweenOut.reset();
  }

  private closeGameWheel = (): void => {
    // console.log(this)
    this.activeGameData.jackPotGame.exitJackpot();

    this.scoreContainer.alpha = 0;
  };

  private setTestValues(value: number, index: number) {
    // this.testMode=true;
    this.winValue = value;
    this.winIndex = index;
  }
  public getCloseBtnContainer = (): PIXI.Container => {
    return this.closeBtnContainer;
  };
}
// let test= new ImageText("this is a test",gameScene)
